const FAQ = () => {
    return (
      <>
        <div>
          <h2 className="font-bold">Marketing introduction</h2>
          <p className="text-sm text-gray-500">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Facilis,
            dolores consectetur! Non at repellendus omnis sapiente quibusdam
            fugit, animi doloribus modi quo corporis ex. Totam, perferendis esse?
            Doloribus, quisquam quae.
          </p>
        </div>
        <div>
          <h2 className="font-bold">Marketing introduction</h2>
          <p className="text-sm text-gray-500">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Facilis,
            dolores consectetur! Non at repellendus omnis sapiente quibusdam
            fugit, animi doloribus modi quo corporis ex. Totam, perferendis esse?
            Doloribus, quisquam quae.
          </p>
        </div>
        <div>
          <h2 className="font-bold">Marketing introduction</h2>
          <p className="text-sm text-gray-500">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Facilis,
            dolores consectetur! Non at repellendus omnis sapiente quibusdam
            fugit, animi doloribus modi quo corporis ex. Totam, perferendis esse?
            Doloribus, quisquam quae.
          </p>
        </div>
        <div>
          <h2 className="font-bold">Marketing introduction</h2>
          <p className="text-sm text-gray-500">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Facilis,
            dolores consectetur! Non at repellendus omnis sapiente quibusdam
            fugit, animi doloribus modi quo corporis ex. Totam, perferendis esse?
            Doloribus, quisquam quae.
          </p>
        </div>
      </>
    );
  };
  
  export default FAQ;
  